// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * TLM Kit
 *
 * Copyright © 2007-present SOHO Systems and Networks. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

:root {
  /*
   * Typography
   * ======================================================================== */

  /*
   * Layout
   * ======================================================================== */

  /*
   * Media queries breakpoints
   * ======================================================================== */  /* Extra small screen / phone */  /* Small screen / tablet */  /* Medium screen / desktop */ /* Large screen / wide desktop */
}

/* @font-face for Oswald is declared globally in /styles/custom.css with
   font-display: optional + size-adjust to prevent CLS on font swap. */

.Rx7Er {
  margin: 0 auto;
  max-width: 100%;
}

.SUUfX {
  list-style-type: square;
  text-align: left;
  font-style: normal !important;
  font-family: Dosis, sans-serif;
  font-size: 18px !important;
}

.OpGjA ul {
  padding-left: 0 !important;
}

.xaUdc {
  display: block;
  text-align: left;
  margin-top: 5px;
  font-size: 18px;
  font-weight: bold;
  position: relative;
  text-transform: uppercase;
  margin-bottom: 5px;
  cursor: pointer;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `Rx7Er`,
	"archiveLink": `SUUfX`,
	"archiveNewsSection": `OpGjA`,
	"archiveYearHeader": `xaUdc`
};
module.exports = ___CSS_LOADER_EXPORT___;
